import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import './AllAdminUserList.css';
import { adminAuth } from '../../../config';

export default function AllAdminListUser() {
    const history = useHistory();
    const [searchTerm, setSearchTerm] = useState("");
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);
    const { username1, password1 } = adminAuth;

    const handleSetClick = (adminId) => {
        history.push(`/admin/new_allservices/${adminId}`);
    };
//TESTINGS_SHWETA
    const accessInfo = async () => {
        try {
            setLoading(true);
           

            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append(
                "Authorization",
                "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
                );
                

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(" "),
                redirect: "follow",
            };

            const res = await fetch(
                `https://api.bumppypay.com/api/Apitranxt/admin/get_all_admin_list_super_admin`,
                requestOptions
            );
            const result = await res.json();

            if (result.status === "0") {
                setServices(result.data);
            }
        } catch (error) {
            console.error("Error fetching services:", error);
            swal("Error", "Failed to load admin list", "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        accessInfo();
    }, []);

   
    const filteredServices = services.filter((service) =>
        service.admin_username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        service.admin_loginid?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredServices.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredServices.length / recordsPerPage);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    return (
        <div className="user_lts-container">
            <div className="user_lts-card">
                <div className="user_lts-header">
                    <h2 className="user_lts-title">Admin All User List</h2>
                    <input
                        type="text"
                        placeholder="Search by username..."
                        className="user_lts-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className="user_lts-table-wrapper">
                    <div className="user_lts-table-div">
                        <div className="user_lts-thead">
                            <div className="user_lts-th">SR.</div>
                            <div className="user_lts-th">Admin Id</div>
                            <div className="user_lts-th">Employee Id</div>
                            <div className="user_lts-th">Username</div>
                            <div className="user_lts-th">Login Id</div>
                            <div className="user_lts-th user_lts-center">Action</div>
                        </div>

                        <div className="user_lts-tbody">
                            {loading ? (
                                <div className="user_lts-loading">Loading admins...</div>
                            ) : currentRecords.length > 0 ? (
                                currentRecords.map((service, index) => (
                                    <div className="user_lts-tr" key={service.pk_admin_id}>
                                        <div className="user_lts-td sr-col">{indexOfFirstRecord + index + 1}</div>
                                        <div className="user_lts-td bold-text">{service.pk_admin_id}</div>
                                        <div className="user_lts-td bold-text">{service.emp_ID}</div>
                                        <div className="user_lts-td bold-text">{service.admin_username}</div>
                                        <div className="user_lts-td bold-text">{service.admin_loginid}</div>
                                        <div className="user_lts-td user_lts-center">
                                            <button
                                                onClick={() => handleSetClick(service.pk_admin_id)}
                                                className="user_lts-set-btn"
                                            >
                                                Set
                                            </button>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="user_lts-loading">No records found.</div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="user_lts-footer">
                    <div className="user_lts-info-text">
                        Showing <b>{indexOfFirstRecord + 1}</b> to <b>{Math.min(indexOfLastRecord, filteredServices.length)}</b> of <b>{filteredServices.length}</b>
                    </div>
                    <div className="user_lts-pagination">
                        <button
                            className="user_lts-page-btn"
                            onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                        {[...Array(totalPages)].map((_, i) => (
                            <button
                                key={i}
                                className={`user_lts-num-btn ${currentPage === i + 1 ? 'active' : ''}`}
                                onClick={() => setCurrentPage(i + 1)}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button
                            className="user_lts-page-btn"
                            onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                            disabled={currentPage === totalPages || totalPages === 0}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
